import $ from 'jquery';

$(function() {

    //initNectarMenu();

});


function initNectarMenu() {

    let isCustomer = ($('body').attr('data-cc') === 'true');
    let isSupplier = ($('body').attr('data-cs') === 'true');

    console.log('Customer: ' + isCustomer);
    console.log('Supplier: ' + isSupplier);

    let $accountMenuItems = $('[data-menu-item-title="Your account"]');
    console.log($accountMenuItems);

    if (!isCustomer && !isSupplier) {
        $accountMenuItems.remove();
    }


}
